import { at } from "lodash";
import { useField } from "formik";
import FormControl from "@mui/material/FormControl";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import FormHelperText from "@mui/material/FormHelperText";
import { styled } from "@mui/material";

const CheckboxField = styled("div")({
  "&  .MuiFormControl-root ": {
    width: "auto",
  },
  "&  .MuiFormControlLabel-root ": {
    marginRight: "10px !important",
    marginLeft: "-5px",
    alignItems: "center !important",
    "&  .MuiCheckbox-root ": {
      margin: 5,
      padding: 0,
    },
  },
});
export default function YSCheckBox(props: any) {
  const { label, ...rest } = props;
  const [field, meta, helper] = useField(props);
  const { setValue } = helper;

  function _renderHelperText() {
    const [touched, error] = at(meta, "touched", "error");
    if (touched && error) {
      return <FormHelperText>{error}</FormHelperText>;
    }
  }

  function _onChange(e: any) {
    setValue(e.target.checked);
  }

  return (
    <CheckboxField>
      <FormControl {...rest}>
        <FormGroup>
          <FormControlLabel
            value={field.value}
            checked={field.value}
            control={
              <Checkbox
                {...field}
                onChange={_onChange}
                defaultChecked={props.defaultChecked}
              />
            }
            label={label}
          />
        </FormGroup>
        {_renderHelperText()}
      </FormControl>
    </CheckboxField>
  );
}
